import { RootState } from '../../store';

export const selectUsers = (state: RootState) => state.userTracker.list;

export const selectListError = (state: RootState) => state.userTracker.listError;

export const selectCurrentUser = (state: RootState) => state.userTracker.current;

export const selectCurrentError = (state: RootState) => state.userTracker.currentError;

export const selectLoading = (state: RootState) => state.userTracker.loading;

export const selectCreateNoteOpened = (state: RootState) => state.userTracker.createNoteOpen;

export const selectCreatingNewNote = (state: RootState) => state.userTracker.creatingNewNote;

export const selectCreateNoteError = (state: RootState) => state.userTracker.createNoteError;

export const selectPaging = (state: RootState) => state.userTracker.paging;

